import React from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";

const NavItem = ({ to, label, icon: Icon, end, collapsed, onClick }) => {
  return (
    <NavLink
      to={to}
      end={end}
      onClick={onClick}
      className={({ isActive }) =>
        `group relative flex items-center gap-3 rounded-md px-3 py-2.5 text-[13px] font-medium transition-all duration-200
        ${
          isActive
            ? "bg-gradient-to-r from-[#5B7CFF]/20 via-[#5B7CFF]/8 to-transparent text-white shadow-[inset_0_0_0_1px_rgba(91,124,255,0.15)]"
            : "text-slate-400 hover:bg-white/[0.05] hover:text-slate-200"
        }`
      }
    >
      {({ isActive }) => (
        <>
          {/* {isActive && (
            <motion.span
              layoutId="active-nav-bar"
              className="absolute left-0 top-1/2 h-5 w-[3px] -translate-y-1/2 rounded-full bg-[#5B7CFF]"
              transition={{ type: "spring", stiffness: 400, damping: 30 }}
            />
          )} */}
          {isActive && (
            <motion.span
              layoutId="active-nav-bar"
              className="absolute left-0 top-0 h-full w-[3px] rounded-r-full bg-[#5B7CFF]"
              transition={{ type: "spring", stiffness: 400, damping: 30 }}
            />
          )}
          <Icon 
            size={17}
            className={`shrink-0 ${isActive ? "text-[#8CA0FF]" : "text-slate-500 group-hover:text-slate-300"}`}
          />
          <span
            className={`overflow-hidden whitespace-nowrap transition-all duration-200 ${
              collapsed ? "lg:w-0 lg:opacity-0" : "w-auto opacity-100"
            }`}
          >
            {label}
          </span>

          {collapsed && (
            <span className="pointer-events-none absolute left-full top-1/2 z-50 ml-3 hidden -translate-y-1/2 whitespace-nowrap rounded-md border border-white/10 bg-[#0D1424] px-2.5 py-1.5 text-[12px] font-medium text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 lg:block">
              {label}
              <span className="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-[#0D1424]" />
            </span>
          )}
        </>
      )}
    </NavLink>
  );
};
export default NavItem;
